<template>
  <div id="print-invoice">
    <div id="testreport-page1" class="p-page d-flex" style="min-height: 50vh">
      <div class="w-100">
        <div class="d-flex justify-content-center p-header">{{ data.companyName }}</div>
        <div class="d-flex justify-content-center">交易出貨清單</div>
        <b-row>
          <b-col cols="7">
            <div>客戶編號：{{ data.customerNo }}</div>
          </b-col>
          <b-col cols="5">
            <div>出貨日期：{{ date }}</div>
          </b-col>
          <b-col cols="12">
            <div>工單編號：{{ caseNo }}</div>
          </b-col>
          <b-col cols="7">
            <div>事業單位：{{ data.name }}</div>
            <div>客戶名稱：{{ data.contactName }}</div>
            <div>客戶地址：{{ data.address }}</div>
          </b-col>
          <b-col cols="5">
            <div>電　　話：{{ data.phone }}</div>
            <div>聯絡電話：{{ data.contactInformation }}</div>
          </b-col>
        </b-row>
        <table class="p-table" v-if="items.length > 0">
          <tr>
            <td class="w-100" colspan="4">
              <b-row>
                <b-col cols="12">資料救援設備：{{ devices }}</b-col>
              </b-row>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <b-row>
                <b-col cols="4" class="d-flex pr-0">
                  <div class="text-nowrap d-flex align-items-start">廠牌：</div>
                  <div class="p-break">{{ brands }}</div>
                </b-col>
                <b-col cols="4" class="d-flex pr-0">
                  <div class="text-nowrap d-flex align-items-start">型號：</div>
                  <div class="p-break">{{ models }}</div>
                </b-col>
                <b-col cols="4" class="d-flex pr-3">
                  <div class="text-nowrap d-flex align-items-start">序號：</div>
                  <div class="p-break">{{ serials }}</div>
                </b-col>
              </b-row>
            </td>
          </tr>
          <tr>
            <td class="w-60 text-center">交易內容</td>
            <td class="w-10 text-center">數量</td>
            <td class="w-15 text-center">單價</td>
            <td class="w-15 ext-center">金額</td>
          </tr>
          <tr v-for="(item, index) in items" :key="index">
            <td class="w-60 p-content">{{ item.content }}</td>
            <td class="w-10 text-right p-content">{{ item.quantity }}</td>
            <td class="w-15 text-right p-content">{{ item.print == null ? "" : $function.priceformatWithMark(item.print) }}</td>
            <td class="w-15 text-right p-content">{{ item.print == null ? "" : $function.priceformatWithMark(item.quantity * item.print) }}</td>
          </tr>

          <tr>
            <td class="w-60 p-board-top text-right">合計：</td>
            <td class="text-right p-board-top" colspan="3">{{ $function.priceformatWithMark(subTotal) }}</td>
          </tr>

          <tr v-if="tax">
            <td class="w-60 p-content text-right">營業稅：</td>
            <td class="text-right p-content" colspan="3">{{ $function.priceformatWithMark(tax) }}</td>
          </tr>

          <tr>
            <td class="w-60 p-board-bottom text-right">總計金額：</td>
            <td class="text-right p-board-bottom" colspan="3">{{ $function.priceformatWithMark(total) }}</td>
          </tr>
        </table>

        <table class="p-table p-margin-top p-table-color" v-if="substances.length > 0">
          <tr>
            <td class="w-60 text-center">交付內容</td>
            <td class="text-right">數量</td>
          </tr>
          <tr v-for="item in substances" :key="item.content">
            <td class="w-60 p-content">{{ item.content }}</td>
            <td class="text-right p-content">{{ item.quantity }}</td>
          </tr>
          <tr>
            <td class="w-60 p-board-bottom"></td>
            <td class="text-right p-board-bottom"></td>
          </tr>
        </table>

        <div class="mt-1">※請盡速確認資料，救援資料僅保留五天(含例假日)</div>
        <div>※售出與提供之備份工具不保固資料，建議養成定期備份習慣，謝謝！</div>
      </div>
      <div class="p-sub-desc">第一聯<br />：客戶</div>
    </div>
    <div id="testreport-page1" class="p-page d-flex" style="min-height: 50vh">
      <div class="w-100">
        <div class="d-flex justify-content-center p-header">{{ data.companyName }}</div>
        <div class="d-flex justify-content-center">交易出貨清單</div>
        <b-row>
          <b-col cols="7">
            <div>客戶編號：{{ data.customerNo }}</div>
          </b-col>
          <b-col cols="5">
            <div>出貨日期：{{ date }}</div>
          </b-col>
          <b-col cols="12">
            <div>工單編號：{{ caseNo }}</div>
          </b-col>
          <b-col cols="7">
            <div>事業單位：{{ data.name }}</div>
            <div>客戶名稱：{{ data.contactName }}</div>
            <div>客戶地址：{{ data.address }}</div>
          </b-col>
          <b-col cols="5">
            <div>聯絡電話：{{ data.contactInformation }}</div>
            <div>電　　話：{{ data.phone }}</div>
            <div>備　　註：</div>
          </b-col>
        </b-row>
        <table class="p-table" v-if="items.length > 0">
          <tr>
            <td class="w-100" colspan="4">
              <b-row>
                <b-col cols="12">資料救援設備：{{ devices }}</b-col>
              </b-row>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <b-row>
                <b-col cols="4" class="d-flex pr-0">
                  <div class="text-nowrap d-flex align-items-start">廠牌：</div>
                  <div class="p-break">{{ brands }}</div>
                </b-col>
                <b-col cols="4" class="d-flex pr-0">
                  <div class="text-nowrap d-flex align-items-start">型號：</div>
                  <div class="p-break">{{ models }}</div>
                </b-col>
                <b-col cols="4" class="d-flex pr-3">
                  <div class="text-nowrap d-flex align-items-start">序號：</div>
                  <div class="p-break">{{ serials }}</div>
                </b-col>
              </b-row>
            </td>
          </tr>
          <tr>
            <td class="w-60 text-center">交易內容</td>
            <td class="w-10 text-center">數量</td>
            <td class="w-15 text-center">單價</td>
            <td class="w-15 ext-center">金額</td>
          </tr>
          <tr v-for="(item, index) in items" :key="index">
            <td class="w-60 p-content">{{ item.content }}</td>
            <td class="w-10 text-right p-content">{{ item.quantity }}</td>
            <td class="w-15 text-right p-content">{{ item.print == null ? "" : $function.priceformatWithMark(item.print) }}</td>
            <td class="w-15 text-right p-content">{{ item.print == null ? "" : $function.priceformatWithMark(item.quantity * item.print) }}</td>
          </tr>

          <tr>
            <td class="w-60 p-board-top text-right">合計：</td>
            <td class="text-right p-board-top" colspan="3">{{ $function.priceformatWithMark(subTotal) }}</td>
          </tr>

          <tr v-if="tax">
            <td class="w-60 p-content text-right">營業稅：</td>
            <td class="text-right p-content" colspan="3">{{ $function.priceformatWithMark(tax) }}</td>
          </tr>

          <tr>
            <td class="w-60 p-board-bottom text-right">總計金額：</td>
            <td class="text-right p-board-bottom" colspan="3">{{ $function.priceformatWithMark(total) }}</td>
          </tr>
        </table>

        <table class="p-table p-margin-top p-table-color" v-if="substances.length > 0">
          <tr>
            <td class="w-60 text-center">交付內容</td>
            <td class="text-right">數量</td>
          </tr>
          <tr v-for="item in substances" :key="item.content">
            <td class="w-60 p-content">{{ item.content }}</td>
            <td class="text-right p-content">{{ item.quantity }}</td>
          </tr>
          <tr>
            <td class="w-60 p-board-bottom"></td>
            <td class="text-right p-board-bottom"></td>
          </tr>
        </table>
        <b-row>
          <b-col>
            <div class="mt-1">※請盡速確認資料，救援資料僅保留五天(含例假日)</div>
          </b-col>
          <b-col class="p-text-big">客戶簽收：</b-col>
        </b-row>
      </div>
      <div class="p-sub-desc">第二聯<br />：會計</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "InvoicePrintPage",
  props: ["data"],
  computed: {
    date() {
      return this.data.invoices[0].date;
    },
    caseNo() {
      return this.data.invoices.map((p) => p.caseNo).join("、");
    },
    devices() {
      let devices = this.data.invoices.map((p) => p.device);
      let devicelist = [];
      devices.forEach((item) => {
        let data = devicelist.find((p) => p.text === item);
        if (data) data.total += 1;
        else
          devicelist.push({
            text: item,
            total: 1,
          });
      });
      return devicelist.map((p) => p.text + "*" + p.total).join("、");
    },
    brands() {
      return this.data.invoices.map((p, index) => index + 1 + "." + p.brand).join("、");
    },
    models() {
      return this.data.invoices.map((p, index) => index + 1 + "." + p.model).join("、");
    },
    serials() {
      return this.data.invoices.map((p, index) => index + 1 + "." + p.serial).join("、");
    },
    items() {
      let result = [];
      this.data.invoices.forEach((invoice) => {
        invoice.items.forEach((item) => {
          result.push({
            content: "(" + invoice.caseNo + ")" + item.content,
            quantity: item.quantity,
            print: item.print,
          });
        });
      });
      return result;
    },
    substances() {
      let query = this.data.invoices.map((p) => p.substances).flat();
      let result = [];
      query.forEach((item) => {
        let data = result.find((p) => p.content === item.content);
        if (data) data.quantity += item.quantity;
        else
          result.push({
            content: item.content,
            quantity: item.quantity,
          });
      });
      return result;
    },
    subTotal() {
      return this.data.invoices.map((p) => p.subTotal).reduce((a, b) => a + b, 0);
    },
    tax() {
      return this.data.invoices.map((p) => p.tax).reduce((a, b) => a + b, 0);
    },
    total() {
      return this.data.invoices.map((p) => p.total).reduce((a, b) => a + b, 0);
    },
  },
};
</script>
<style lang="scss" scoped>
@media print {
  #print-invoice {
    display: block !important;
    height: 100%;
    background-color: #fff;
  }

  .p-table-color {
    td {
      background-color: #d9d9d9 !important;
    }
  }
}

#print-invoice {
  display: none;
  font-weight: 900;
  font-size: 18px;
  font-family: "微軟正黑體";
}

.p-sub-desc {
  width: 24px;
  padding-left: 5px;
  padding-top: 200px;
}

.p-table-color {
  td {
    background-color: #d9d9d9 !important;
  }
}

.p-table {
  width: 100%;

  .w-33 {
    width: 33%;
  }

  .w-10 {
    width: 10%;
  }

  .w-60 {
    width: 60%;
  }

  .w-15 {
    width: 15%;
  }

  td {
    border: 1px solid black;
  }

  .p-content {
    border-top-width: 0;
    border-bottom-width: 0;
  }

  .p-board-top {
    border-bottom-width: 0;
  }

  .p-board-bottom {
    border-top-width: 0;
  }
}

.p-page {
  padding-left: 50px;
  padding-right: 26px;
}

.p-header {
  padding-bottom: 8px;
  font-size: 40px;
}

.p-text-big {
  font-size: 28px;
}

.p-margin {
  margin-bottom: 16px;
}

.p-margin-top {
  margin-top: 24px;
}

.p-margin-top-max {
  margin-top: 300px;
}

.p-margin-x {
  margin-top: 38px;
  margin-bottom: 38px;
}

.p-break {
  word-wrap: break-word;
  word-break: break-all;
  overflow-wrap: break-word;
}
</style>